import React from 'react';
import PropTypes from 'prop-types';
import {HeadLabel, HeadWrapper, ErrorWrapper} from 'src/components/AdminUsers/UserDetails.style';

function UserDetails({ user, tableauLogin, isError, tableauDashboards, isSuperUser, staffId }) {

    if (!user) {
        return <div></div>;
    }
    return (
        <div className='admin-users__user-details'>
            <h3>Details</h3>
            <h4>Name:</h4>
            <div data-test='name'>{ user.get('name') }</div>
            <h4>Email:</h4>
            <div data-test='email'>{ user.get('email') }</div>
            <h4>First name:</h4>
            <div data-test='first-name'>{ user.get('firstName') }</div>
            <h4>Surname:</h4>
            <div data-test='surname'>{ user.get('surname') }</div>
            <h4>Job title:</h4>
            <div data-test='job-title'>{ user.get('jobTitle') }</div>
            <h4>Status:</h4>
            { user.get('status') }
            { (tableauDashboards === true && (isSuperUser === true || staffId === user.get('id'))) ?
                <div>
                    <HeadWrapper>
                        <HeadLabel>Tableau Login:</HeadLabel>
                        { isError === true ? <ErrorWrapper>Request Error</ErrorWrapper> : null }
                    </HeadWrapper>
                    { tableauLogin === '' ? 'not defined' : tableauLogin }
                </div> :
                null 
            }
            <h4>Status description:</h4>
            { user.get('statusDescription') }
        </div>
    );
}

export default UserDetails;
